module.exports = function() {
  return new Worker(__webpack_public_path__ + "987e837ba6fe2930c0bf.worker.js");
};